export const REPLY_EDITOR_MODES = {
  REPLY: 'REPLY',
  NOTE: 'NOTE',
  // Not a way of writing, unlike the two above it: nothing is composed here and nothing is sent.
  // It sits with them because it belongs to the same moment — the agent has just opened a chat
  // and is deciding what to say, and the summary is where that decision starts.
  AI_NOTE: 'AI_NOTE',
};

export const CHAR_LENGTH_WARNING = {
  UNDER_50: 'characters remaining',
  NEGATIVE: 'characters over',
};
